import { render, staticRenderFns } from "./AddWorkExperienceForm.vue?vue&type=template&id=60c2f45f&"
import script from "./AddWorkExperienceForm.vue?vue&type=script&lang=ts&"
export * from "./AddWorkExperienceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports